import { ErrorHandler } from '@angular/core';
import * as angular from 'angular';

export const ModeCommonConfigsModule = angular
  .module('mode.common.configs', [])

  .config([
    '$httpProvider',
    function ($httpProvider) {
      $httpProvider.useApplyAsync(true);
    },
  ])

  .config([
    '$provide',
    '$qProvider',
    function ($provide, $qProvider) {
      // Prevent unhandled rejections from being raised
      $qProvider.errorOnUnhandledRejections(false);

      // Enhance exceptionHandler
      $provide.decorator('$exceptionHandler', [
        'AngularErrorHandler',
        function (handler: ErrorHandler) {
          return function (exception, cause) {
            // Forward the exception to the outer Error Handler
            handler.handleError(exception);
          };
        },
      ]);
    },
  ]).name;
